import { useEffect, useState, useRef } from "react";
import styles from "./shop.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoaderCstm from "../../../components/Loader";
import tokenIcn from "../../../assets/images/usdt-ton.png";
// import { showToast } from "../../../helper/common";
import { Button, Container, Col, Row } from "react-bootstrap";
import current from "../../../assets/images/current.png";
import {
  cancelOrderBitanicaPay,
  getEnergyPackages,
  getUserProfile,
  // getPurchaseLink,
  // checkPaymentStatus,
  // getUserProfile,
  // cancelPayment
} from "../../../lib/store/actions";
// import { useTonConnectUI } from '@tonconnect/ui-react';
import EnergyShop from "../../../components/Modals/EnergyShopPop";
import { useWindow } from "../../../hooks/useWindow";
import BitanicaIframePop from "../../../components/Modals/BitanicaIframePop";
import CancelOrderConfirmationPopup from "../../../components/Modals/cancelOrderConfirmation";
import { useGameContext } from "../../../context/GameContext";
import { useLanguage } from "../../../hooks/useLanguage";

const Shop = () => {
  const t = useLanguage();
  const { setGameEnergyLeft, setBtncBalance } = useGameContext();
  const navigate = useNavigate();
  // const [tonConnectUI] = useTonConnectUI();
  // const [loading, setLoading] = useState(false);
  // const [verify, setVerify] = useState(false);

  const [scrollStopOn, setScrollStopOn] = useState(false);
  const [showEnergyPackage, setShowEnergyPackage] = useState(false);
  const [packageItem, setPackageItem] = useState(null);
  const [bitanicaIframe, setBitanicaIframe] = useState();
  const [iframeData, setIframeData] = useState("");
  const [showCancelOrderConfirmation, setShowCancelOrderConfirmation] =
    useState("");
  const [cancelOrderLoading, setCancelOrderLoading] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const dispatch = useDispatch();
  const {
    loadingEnergyPackages,
    energyPackageList,
    settingsData,
    userData,
    totalEnergyPackages,
  } = useSelector(({ Settings, Auth, Energy }) => ({
    userData: Auth.user,
    loadingEnergyPackages: Energy.loadingEnergyPackages,
    energyPackageList: Energy.energyPackageList,
    totalEnergyPackages: Energy.totalEnergyPackages,
    settingsData: Settings.settings,
  }));

  useEffect(() => {
    dispatch(
      getEnergyPackages({
        data: {
          page: 1,
          limit: 20,
          order: -1,
          orderBy: "date_created_utc",
        },
      }),
    );
  }, [dispatch]);

  const openHistoryPage = async () => {
    try {
      navigate("/shop-history");
    } catch (error) {
      console.error("error", error);
    }
  };

  const openPopup = async (pkg) => {
    try {
      setPackageItem(pkg);
      setShowEnergyPackage(true);
    } catch (error) {
      console.error("error opening popup", error);
    }
  };

  const {
    screenSize: { dynamicHeight },
  } = useWindow();
  const elementRef = useRef(null);

  useEffect(() => {
    const calculateScrollStop = () => {
      if (elementRef.current) {
        const elementHeight = elementRef.current.offsetHeight;

        setScrollStopOn(dynamicHeight - 128 > elementHeight);
        calculateScrollStop();

        // Optional: Listen for window resize to update the calculation dynamically
        window.addEventListener("resize", calculateScrollStop);
        return () => window.removeEventListener("resize", calculateScrollStop);
      }
    };
  }, [dynamicHeight, energyPackageList]);

  const handleCancelOrder = async () => {
    try {
      setCancelOrderLoading(true);

      if (userData?._id) {
        const cancelBody = {
          orderId: iframeData?.order_id,
        };

        const result = await dispatch(
          cancelOrderBitanicaPay({
            data: cancelBody,
          }),
        );

        if (cancelOrderBitanicaPay.fulfilled.match(result)) {
          const bodyParams = {
            _id: userData._id,
          };

          dispatch(
            getUserProfile({
              data: bodyParams,
              callBack: (err, res) => {
                if (!err && res?.status === "success") {
                  setGameEnergyLeft(res?.data?.energyBalance || 0);
                  setBtncBalance(res?.data?.btncBalance || 0);
                }
              },
            }),
          );

          setBitanicaIframe(false);
        }
      } else {
        setBitanicaIframe(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCancelOrderLoading(false);
    }
  };

  return (
    <>
      {showCancelOrderConfirmation && (
        <CancelOrderConfirmationPopup
          showCancelOrderConfirmation={showCancelOrderConfirmation}
          setShowCancelOrderConfirmation={setShowCancelOrderConfirmation}
          onFinish={handleCancelOrder}
          cancelOrderLoading={cancelOrderLoading}
        />
      )}
      {showEnergyPackage && (
        <EnergyShop
          showEnergyPackage={showEnergyPackage}
          setShowEnergyPackage={setShowEnergyPackage}
          packageItem={packageItem}
          setIframeData={setIframeData}
          setBitanicaIframe={setBitanicaIframe}
        />
      )}
      {bitanicaIframe && (
        <BitanicaIframePop
          bitanicaIframe={bitanicaIframe}
          setBitanicaIframe={setBitanicaIframe}
          iframeData={iframeData}
          setShowCancelOrderConfirmation={setShowCancelOrderConfirmation}
          cancelOrderLoading={cancelOrderLoading}
        />
      )}
      <section
        className={`${styles.shop} position-relative ${
          scrollStopOn && totalEnergyPackages <= 10 ? "no-minimize" : ""
        }`}
      >
        <Container>
          <Row>
            <Col lg="12" className="py-2">
              <div className="top text-center d-flex justify-content-center position-relative align-items-center">
                <h5 className="m-0 themeClr2 fw-bold">
                  {" "}
                  {t("energyshop_page.title")}
                </h5>
                <button
                  onClick={() => openHistoryPage()}
                  className="bg-transparent border-0 p-0 position-absolute"
                  style={{ right: 0, top: 0 }}
                >
                  <span className="icn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 10 14"
                      fill="none"
                    >
                      <path
                        d="M8.13154 0.778896C9.28809 1.2942 10.2546 2.20136 10.8815 3.35989C11.5082 4.5184 11.7604 5.86364 11.5988 7.18722C11.4373 8.51077 10.871 9.73883 9.98765 10.6812C9.10435 11.6236 7.95336 12.2276 6.7129 12.3998C5.47245 12.5721 4.21179 12.3028 3.12615 11.6337C2.04052 10.9647 1.19051 9.93324 0.707775 8.69908C0.556277 8.31175 0.727231 7.86795 1.08961 7.70788C1.452 7.54772 1.86858 7.73188 2.02008 8.11922C2.38213 9.0448 3.01963 9.81845 3.83386 10.3202C4.64808 10.822 5.59358 11.0239 6.52392 10.8948C7.45428 10.7656 8.31748 10.3126 8.97996 9.60583C9.64244 8.89908 10.0672 7.978 10.1883 6.98531C10.3096 5.99263 10.1204 4.98371 9.65028 4.11482C9.18017 3.24593 8.45533 2.56556 7.58792 2.17908C6.72052 1.7926 5.75903 1.72158 4.85238 1.97703C4.25916 2.14416 3.71109 2.44494 3.24289 2.85474L3.73856 3.43944C4.16443 3.9418 3.81052 4.74041 3.17766 4.70511L0.342864 4.54697L0.479853 1.52272C0.510436 0.847567 1.2909 0.552139 1.71678 1.0545L2.28603 1.72601C2.9216 1.15597 3.67109 0.738576 4.48417 0.509496C5.69306 0.168903 6.97504 0.263592 8.13154 0.778896ZM6.09435 3.34832C6.48667 3.37021 6.78933 3.72724 6.77037 4.14578L6.68161 6.10535L7.83566 7.46668C8.09964 7.77811 8.07791 8.25795 7.78711 8.53841C7.49631 8.81887 7.04653 8.79377 6.78252 8.48237L5.23247 6.6539L5.34967 4.06652C5.36862 3.64799 5.70203 3.32644 6.09435 3.34832Z"
                        fill="#54B3F5"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              {loadingEnergyPackages && <LoaderCstm />}
              {!loadingEnergyPackages && !energyPackageList?.length ? (
                <div className="d-flex justify-content-center align-items-center">
                  <span>{t("energyshop_page.no_record_found")}</span>
                </div>
              ) : null}
              <div
                className="row overflow-auto py-3 mx-auto allow-scroll"
                style={{
                  maxWidth: 374,
                  maxHeight: "calc(100vh - 128px)",
                  overflowY: "scroll",
                  height: "auto",
                }}
              >
                {energyPackageList?.map((pkg) => (
                  <div
                    className=""
                    onClick={() => {
                      openPopup(pkg);
                    }}
                  >
                    <div
                      key={pkg._id}
                      className="card rounded-4 mb-2 ps-3"
                      style={{ backgroundColor: "#13131B", paddingRight: 35 }}
                    >
                      <div className="card-body row text-white py-2 align-items-center px-0">
                        {pkg?.isHotOffer ? (
                          <div className="col-5 flex-shrink-0 position-relative">
                            <div
                              className={`${styles.hotOffer} position-absolute d-flex align-items-center px-2`}
                              style={{
                                background: "#242AFC",
                                top: -18,
                                left: 15,
                              }}
                            >
                              <span className="icn me-1">{clockIcn}</span>
                              <p className="m-0 text-white">Hot offer</p>
                            </div>
                            <img
                              src={pkg?.logo}
                              alt=""
                              className="img-fluid object-fit-contain align-items-center"
                              style={{
                                height: "100%",
                                maxHeight: 80,
                                marginTop: 12,
                                marginLeft: 15,
                              }}
                            />
                          </div>
                        ) : (
                          <div className="col-5">
                            <img
                              className="img-fluid object-fit-contain align-items-center"
                              style={{
                                height: "100%",
                                maxHeight: 80,
                                marginTop: 12,
                                marginLeft: 15,
                              }}
                              src={pkg?.logo}
                              alt="Energy Icon"
                            />
                          </div>
                        )}

                        <div className="d-flex flex-column col-7">
                          <h2
                            className="card-title fw-bold"
                            style={{ fontSize: 16 }}
                          >
                            {t("energyshop_page.energy")}
                          </h2>

                          <div className="d-flex justify-content-between align-items-center w-100 gap-10">
                            <div className="d-flex align-items-center badge">
                              <img
                                className="img-fluid"
                                src={current}
                                alt="Icon"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  marginRight: "2px",
                                }}
                              />
                              <span
                                className="fw-bold"
                                style={{
                                  fontSize: "16px",
                                }}
                              >
                                {pkg?.energy}{" "}
                                <span style={{ fontSize: 10 }}>X</span>{" "}
                              </span>
                            </div>
                            <span
                              className="badge px-3 py-2"
                              style={{
                                fontSize: "10px",
                                background: "#1B223A",
                              }}
                            >
                              {pkg?.name}
                            </span>
                          </div>

                          <Button
                            variant="primary"
                            className={`${styles.submitBtn} w-100 d-flex align-items-center justify-content-center gap-10 fw-bold mt-3`}
                            // onClick={() => handlePurchase(pkg?._id, pkg?.energy)}
                            disabled={
                              settingsData?.energy?.maxEnergyBalance <
                              userData?.energyBalance + pkg?.energy
                            }
                          >
                            {pkg?.discountPercent > 0 && (
                              <del
                                className=""
                                style={{
                                  color: "#9194FE",
                                  fontWeight: 400,
                                  fontSize: 10,
                                }}
                              >
                                <img
                                  src={tokenIcn}
                                  style={{ height: 16, width: 16 }}
                                  alt=""
                                  className="img-fluid flex-shrink-0 object-fit-contain"
                                />{" "}
                                {pkg?.price}
                              </del>
                            )}
                            <img
                              src={tokenIcn}
                              style={{ height: 20, width: 20 }}
                              alt=""
                              className="img-fluid flex-shrink-0 object-fit-contain"
                            />
                            {pkg?.discountedPrice}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Shop;

const clockIcn = (
  <svg
    width="9"
    height="9"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.22932 3.80942C6.22932 5.20066 5.10214 6.32978 3.71329 6.32978C2.32445 6.32978 1.19727 5.20066 1.19727 3.80942C1.19727 2.41818 2.32445 1.28906 3.71329 1.28906C5.10214 1.28906 6.22932 2.41818 6.22932 3.80942Z"
      stroke="white"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.64763 4.61085L3.86766 4.14458C3.7318 4.06393 3.62109 3.86986 3.62109 3.71108V2.67773"
      stroke="white"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
